import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { receiveMessage } from '../api/zendesk'
import * as vtex from '../api/vtex'

export const OrderContext = React.createContext()

export default function OrderContextProvider(props) {
    const history = useHistory()
    const [order, setOrder] = useState(null)
    const [conversations, setConversations] = useState({
        order: null,
        orderConversations: []
    })

    useEffect(() => {
        receiveMessage().then(async orderId => {
            const orderConversations = await vtex.getOrderConversations(orderId)
            const completeOrder = await vtex.getOrder(orderId)
            setConversations(orderConversations)
            setOrder(completeOrder)
            history.push('/modal/informacoes')
        })
    }, [])

    return <OrderContext.Provider value={{order, conversations}}>
        {props.children}
    </OrderContext.Provider>
}